import Blocks, { HeroComponents } from '@blocks';
import Layout from '@components/Layout';

import styles from './templateStyles.module.css';

import siteInfo from '@content/default.json';

const formatHeroMap = {
  formatHeroTerminal: 'FormatHeroWithTerminal',
  formatHeroCta: 'FormatHeroWithCallToAction',
  formatHeroIllustration: 'FormatHeroWithIllustration',
};

const FormatTemplate = ({ content, allFormats, menu }) => {
  const { CallToActionCard, Resources, FormatsIntegrationBlock } = Blocks;

  const HeroComponent = HeroComponents[formatHeroMap[content.hero._type]];
  return (
    <Layout heroTheme="dark" menu={menu}>
      <HeroComponent
        {...content.hero}
        eyebrow="Product / Formats"
        markerColor={content.hero.gradient}
        terminalGradient={content.hero.gradient}
        logo={content.logoId}
      />
      <main className={styles.main}>
        {content.blocks?.map((block, i) => {
          const Block = Blocks[block.type];
          return <Block key={i} {...block} />;
        })}

        <Resources
          heading={
            content.resources.heading ??
            `We're here to help you get started with ${content.name} on Cloudsmith`
          }
          intro={content.resources.intro}
          links={content.resources.links}
          video={content.resources.video}
          wistiaVideo={content.resources.wistiaVideo}
          theme="dark"
        />

        <CallToActionCard
          actions={[
            {
              label: 'Book a demo',
              type: 'primary',
              href: siteInfo.bookDemoURL,
            },
          ]}
          claim={
            content.cta?.claim ??
            `Get started with ${content.name} on Cloudsmith.`
          }
          subline={content.cta?.subline}
          listItems={content.cta?.listItems}
          align="left"
          theme="dark"
          illustration="Simple"
        />

        <FormatsIntegrationBlock
          eyebrow="Formats"
          theme="light"
          heading={`There’s more than just ${content.name} on Cloudsmith`}
          formats={allFormats}
          links={[
            {
              label: 'See all formats',
              href: '/product/formats',
            },
          ]}
        />
      </main>
    </Layout>
  );
};

export default FormatTemplate;
